import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';
import { config } from '../config';


@Injectable({
  providedIn: 'root'
})
export class RestaurantService {
  private RESTAURANT_ID: string;
  private token: string;

  constructor(private http: HttpClient) {
    this.RESTAURANT_ID = sessionStorage.getItem('restaurant_id') || '';
    this.token = sessionStorage.getItem('token') || '';
  }

  addNewRestaurant(newRes: any) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL_ADMIN + 'configureNewRestaurant';
    return this.http.post(url, newRes, { headers: headers });
  }

  updateRestaurantConfigById(body: any, resID: any) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL_ADMIN + 'updateConfig?id=' + resID;
    return this.http.post<any>(url, body, { headers: headers });
  }

  getAllSubscription(resID: any) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL_ADMIN + 'getSubscriptions?restaurant_id=' + resID;
    return this.http.get(url, { headers: headers });
  }
  updateSubscription(data: any, id: any) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL_ADMIN + 'updateSubscription?id=' + id;
    return this.http.put(url, data, { headers: headers });
  }
  deleteSubscription(id: any) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL_ADMIN + 'deleteSubscription?id=' + id;
    return this.http.delete(url, { headers: headers });
  }



  fetchRestConfigList() {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL_ADMIN + 'restaurantConfig';
    return this.http.get<any>(url, { headers: headers });
  }

  removeRestaurant(id: string) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    let params = new HttpParams();
    params = params.set('_id', id);
    const url = config.API_URL_ADMIN + 'removeRestaurant';
    return this.http.delete(url, { headers: headers, params: params });
  }

  fetchRestaurantFullList() {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL_ADMIN + 'restaurantFullList';
    return this.http.get<any>(url, { headers: headers });
  }

  getRestaurantList(
    pageNumber: number = 1,
    itemsPerPage: number = 10,
    options: { sortBy?: string; sortOrder?: 'asc' | 'desc'; startsWith?: string } = {}
  ) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    let params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('nPerPage', itemsPerPage.toString());

    if (options.sortBy) params = params.set('sortBy', options.sortBy);
    if (options.sortOrder) params = params.set('sortOrder', options.sortOrder);
    if (options.startsWith) params = params.set('startsWith', options.startsWith);

    const url = config.API_URL_ADMIN + 'restaurantList';
    return this.http.get<any>(url, { headers: headers, params: params });
  }
  searchRestaurants(
    pageNumber: number = 1,
    itemsPerPage: number = 10,
    searchCriteria: {
      name?: string;
      city?: string;
      postcode?: string;
      is_collection?: boolean;
      is_delivery?: boolean;
      is_reservation?: boolean;
      restaurant_mode?: string;
      payment_options?: string;
    } = {},
    options: { sortBy?: string; sortOrder?: 'asc' | 'desc'; startsWith?: string } = {}
  ) {
    let params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('nPerPage', itemsPerPage.toString());
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);

    if (searchCriteria.name) params = params.set('name', searchCriteria.name);
    if (searchCriteria.city) params = params.set('city', searchCriteria.city);
    if (searchCriteria.postcode) params = params.set('postcode', searchCriteria.postcode);
    if (searchCriteria.is_collection) params = params.set('is_collection', searchCriteria.is_collection.toString());
    if (searchCriteria.is_delivery) params = params.set('is_delivery', searchCriteria.is_delivery.toString());
    if (searchCriteria.is_reservation) params = params.set('is_reservation', searchCriteria.is_reservation.toString());
    if (searchCriteria.restaurant_mode) params = params.set('restaurant_mode', searchCriteria.restaurant_mode);
    if (searchCriteria.payment_options) params = params.set('payment_options', searchCriteria.payment_options);
    if (options.sortBy) params = params.set('sortBy', options.sortBy);
    if (options.sortOrder) params = params.set('sortOrder', options.sortOrder);
    if (options.startsWith) params = params.set('startsWith', options.startsWith);

    const url = config.API_URL_ADMIN + 'searchRestaurant';
    return this.http.get<any>(url, { headers, params });
  }

  superAdminDashboardData() {
    return this.getSuperAdminDashboard();
  }

  getSuperAdminDashboard(filters: { range?: string; from?: string; to?: string } = {}) {
    this.token = sessionStorage.getItem('token') || '';
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    let params = new HttpParams();
    if (filters.range) {
      params = params.set('range', filters.range);
    }
    if (filters.from) {
      params = params.set('from', filters.from);
    }
    if (filters.to) {
      params = params.set('to', filters.to);
    }
    const url = config.API_URL_ADMIN + 'dashboard';
    return this.http.get(url, { headers: headers, params: params });
  }

  getRestaurantHealthScorecard(filters: { range?: string; from?: string; to?: string } = {}) {
    this.token = sessionStorage.getItem('token') || '';
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    let params = new HttpParams();
    if (filters.range) { params = params.set('range', filters.range); }
    if (filters.from) { params = params.set('from', filters.from); }
    if (filters.to) { params = params.set('to', filters.to); }
    const url = config.API_URL_ADMIN + 'restaurantHealthScorecard';
    return this.http.get<any>(url, { headers, params });
  }

  getRevenueBreakdown(filters: { range?: string; from?: string; to?: string } = {}) {
    this.token = sessionStorage.getItem('token') || '';
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    let params = new HttpParams();
    if (filters.range) { params = params.set('range', filters.range); }
    if (filters.from) { params = params.set('from', filters.from); }
    if (filters.to) { params = params.set('to', filters.to); }
    const url = config.API_URL_ADMIN + 'revenueBreakdown';
    return this.http.get<any>(url, { headers, params });
  }

  getDashboardDataByRestaurant() {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL_ADMIN + 'dashboard/' + this.RESTAURANT_ID;
    return this.http.get(url, { headers: headers });
  }



  getOneRestaurant(restaurantId: string) {
    const url = config.API_URL_ADMIN + '__getOne/' + restaurantId;
    return this.http.get(url);
  }

  resDataSyncByResId(resId: string) {
    const restaurant = JSON.parse(sessionStorage.getItem('restaurant_data') || '{}');
    const restaurantDomain = restaurant && restaurant.domain ? restaurant.domain : '';
    const url = config.API_URL_ADMIN + 'redisCacheSync/' + resId;
    return this.http.get(url + '?hostname=' + restaurantDomain);
  }

  getBasicSetting() {
    const url = config.API_URL_ADMIN + 'basic/' + this.RESTAURANT_ID;
    return this.http.get(url);
  }

  getGeoLocation(postCode: string) {
    const url = config.API_URL_ADMIN + 'setGeoLocationFromGoogle?restaurant_id=' + this.RESTAURANT_ID + '&address=' + postCode;
    return this.http.get(url);
  }

  updateBasicSetting(data: any) {
    const restaurant = JSON.parse(sessionStorage.getItem('restaurant_data') || '{}');
    const restaurantDomain = restaurant && restaurant.domain ? restaurant.domain : '';
    delete data._id;
    const url = config.API_URL_ADMIN + 'updateBasicInfo?hostname=' + restaurantDomain;
    data.restaurant_id = this.RESTAURANT_ID;
    return this.http.put(url, data);
  }

  addSocialMedia(item: any) {
    const data = { 'restaurant_id': this.RESTAURANT_ID, 'data': item }
    const url = config.API_URL_ADMIN + '__createSocialMedia';
    return this.http.post(url, data);
  }

  deleteSocialMedia(id: string) {
    const data = { restaurant_id: this.RESTAURANT_ID, _id: id };
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    const reqx = new HttpRequest('POST', config.API_URL_ADMIN + '__deleteSocialMedia', data, {
      reportProgress: true,
      headers: headers
    });
    return this.http.request(reqx);
  }


  getSocialList() {
    const url = config.API_URL_ADMIN + 'getSocialMediaList/' + this.RESTAURANT_ID;
    return this.http.get(url);
  }

  getDeliveryArea() {
    const url = config.API_URL + 'v1/getDeliveryAreas/' + this.RESTAURANT_ID;
    return this.http.get(url);
  }

  addOffer(item: any) {
    const data = { restaurant_id: this.RESTAURANT_ID, data: item };
    const url = config.API_URL_ADMIN + 'addOffer';
    return this.http.put(url, data);
  }

  updateOffer(item: any) {
    const data = { restaurant_id: this.RESTAURANT_ID, offer_id: item._id, data: item };
    const url = config.API_URL_ADMIN + 'updateOfferData';
    return this.http.put(url, data);
  }

  deleteOffer(item: string) {
    const data = { restaurant_id: this.RESTAURANT_ID, offer_id: item };
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    const reqx = new HttpRequest('DELETE', config.API_URL_ADMIN + 'deleteOffer', data, {
      reportProgress: true,
      headers: headers
    });
    return this.http.request(reqx);
  }

  addDiscount(item: any) {
    const data = { restaurant_id: this.RESTAURANT_ID, data: item };
    const url = config.API_URL_ADMIN + 'addDiscount';
    return this.http.put(url, data);
  }

  updateDiscount(item: any) {
    const data = { restaurant_id: this.RESTAURANT_ID, discount_id: item._id, data: item };
    const url = config.API_URL_ADMIN + 'updateDiscountData';
    return this.http.put(url, data);
  }

  deleteDiscount(item: string) {
    const data = { restaurant_id: this.RESTAURANT_ID, discount_id: item };
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    const reqx = new HttpRequest('DELETE', config.API_URL_ADMIN + 'deleteDiscount', data, {
      reportProgress: true,
      headers: headers
    });
    return this.http.request(reqx);
  }

  addDeal(item: any) {
    item.restaurant_id = this.RESTAURANT_ID;
    const url = config.API_URL_ADMIN + 'createDeals';
    return this.http.post(url, item);
  }

  updateDeal(data: any) {
    const url = config.API_URL_ADMIN + 'updateBookingDeal';
    return this.http.put(url, data);
  }

  deleteDeal(item: string) {
    const data = { restaurant_id: this.RESTAURANT_ID, _id: item };
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    const reqx = new HttpRequest('DELETE', config.API_URL_ADMIN + 'deleteBookingDeal', data, {
      reportProgress: true,
      headers: headers
    });
    return this.http.request(reqx);
  }


  getUserList(page: number) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL_ADMIN + 'userList/' + this.RESTAURANT_ID + '/' + page;
    return this.http.get(url, { headers: headers });
  }

  addNewSystemUser(user: any) {
    user.restaurant_id = this.RESTAURANT_ID;
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL + 'v1/auth/addNewSystemUser';
    return this.http.post(url, user, { headers: headers });
  }

  getSystemUserList() {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL + 'v1/auth/getSystemUserList/' + this.RESTAURANT_ID;
    return this.http.get(url, { headers: headers });
  }

  changeSystemUserStatus(userId: string, status: boolean) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    let params = new HttpParams();
    params = params.set('uid', userId);
    params = params.set('status', status.toString());
    const url = config.API_URL + 'v1/auth/disableSystemUser';
    return this.http.get(url, { headers: headers, params: params });
  }

  updateSystemUser(data: any) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL + 'v1/auth/updateSystemUser';
    return this.http.put(url, data, { headers: headers });
  }

  removeSystemUser(userId: string) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    let params = new HttpParams();
    params = params.set('_id', userId);
    const url = config.API_URL + 'v1/auth/removeSystemUser';
    return this.http.delete(url, { headers: headers, params: params });
  }




  getRestaurantReviews() {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL_ADMIN + 'restaurantReviews/' + this.RESTAURANT_ID;
    return this.http.get(url, { headers: headers });
  }

  replyToReview(reviewId: any, reviewText: any) {
    const replyData = { _id: reviewId, reply_text: reviewText };
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL_ADMIN + 'replyToReview';
    return this.http.post(url, replyData, { headers: headers });
  }


  deleteRestaurantReviews(itemId: string) {
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', 'Bearer ' + this.token);

    const url = `${config.API_URL_ADMIN}removeReviewById?_id=${itemId}`;
    return this.http.delete(url, { headers });
  }


  getbookingSetting() {
    let params = new HttpParams();
    params = params.set('restaurant_id', this.RESTAURANT_ID);
    const url = config.API_URL_ADMIN + 'admin_getBookingInfo';
    return this.http.get(url, { params: params });
  }

  addBookingSetting(data: any) {
    data.restaurant_id = this.RESTAURANT_ID;
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL_ADMIN + 'addBookingManagementInfo';
    return this.http.post(url, data, { headers: headers });
  }

  updateBookingSetting(data: any) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL_ADMIN + 'updateBookingSetting';
    return this.http.put(url, data, { headers: headers });
  }

  deleteBookingSetting(item: string) {
    const data = { _id: item };
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    const reqx = new HttpRequest('DELETE', config.API_URL_ADMIN + 'removeItemBookingSetting', data, {
      reportProgress: true,
      headers: headers
    });
    return this.http.request(reqx);
  }

  getCouponListData(query: any = {}) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL_ADMIN + 'getAllPromos?restaurant_id=' + this.RESTAURANT_ID;
    let params = new HttpParams().set('restaurant_id', this.RESTAURANT_ID);
    if (query.page) { params = params.set('page', String(query.page)); }
    if (query.limit) { params = params.set('limit', String(query.limit)); }
    if (query.search) { params = params.set('search', String(query.search)); }
    if (query.tab) { params = params.set('tab', String(query.tab)); }
    if (query.sortBy) { params = params.set('sortBy', String(query.sortBy)); }
    if (query.order) { params = params.set('order', String(query.order)); }
    if (query.couponFor && query.couponFor !== 'all') { params = params.set('couponFor', String(query.couponFor)); }
    if (query.is_active !== undefined && query.is_active !== '' && query.is_active !== null) {
      params = params.set('is_active', String(query.is_active));
    }
    return this.http.get<any>(config.API_URL_ADMIN + 'getAllPromos', { headers: headers, params: params });
  }

  addCoupon(item: any) {
    const data = { ...item, restaurant_id: this.RESTAURANT_ID };
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL_ADMIN + 'createPromoCode';
    return this.http.post(url, data, { headers: headers });
  }

  updateCoupon(data: any) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL_ADMIN + 'updatePromoById';
    return this.http.put(url, data, { headers: headers });
  }

  toggleCouponStatus(id: string, isActive: boolean) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL_ADMIN + 'togglePromoStatus';
    return this.http.patch(url, { _id: id, is_active: isActive }, { headers: headers });
  }

  getCouponUsageById(couponId: string) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    let params = new HttpParams().set('_id', couponId);
    const url = config.API_URL_ADMIN + 'getPromoUsageById';
    return this.http.get<any>(url, { headers: headers, params: params });
  }

  getCouponOrders(couponId: string, page: number = 1, limit: number = 20) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    let params = new HttpParams()
      .set('_id', couponId)
      .set('page', String(page))
      .set('limit', String(limit));
    const url = config.API_URL_ADMIN + 'getPromoOrders';
    return this.http.get<any>(url, { headers: headers, params: params });
  }

  deleteCoupon(couponId: string) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL_ADMIN + 'removePromosById';
    let params = new HttpParams();
    params = params.set('_id', couponId);
    return this.http.delete(url, { headers: headers, params: params });
  }

  getVersionInfo() {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL + 'v1/getVersionInfo?restaurant_id=' + this.RESTAURANT_ID;
    return this.http.get<any>(url, { headers: headers });
  }

  createVersionInfo(data: any) {
    data.restaurant_id = this.RESTAURANT_ID;
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL_ADMIN + 'createAppVersion';
    return this.http.post<any>(url, data, { headers: headers });
  }

  updateVersionInfo(body: any, paramID: string) {
    body.restaurant_id = this.RESTAURANT_ID;
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.token);
    const url = config.API_URL_ADMIN + 'updateAppVersionControl?_id=' + paramID;
    return this.http.put<any>(url, body, { headers: headers });
  }

}
